<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sWm6y5/tc-custom/9781617458859.jpg?1731210704670" alt="This image is the cover for the book Artful Embroidery on Canvas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Artful Embroidery on Canvas
      </h1>
      <p class="bookDescription body article font2">
        <p>Transform ordinary artist canvas into an embroidered masterpiece! With easy-to-learn stitches, your embroidery needle becomes a paintbrush to stitch creative ideas into life. Get your feet wet with small art pieces and step-by-step techniques for stitching on stretched canvas. Gather supplies to add appliqué, acrylic paint, fibers, beads, and even mirrors to your mixed-media pieces! Get tips on how to finish and display canvas embroidery art, with an extensive project gallery for inspiration. It’s like art quilting for needlework lovers!  Embellish unique art pieces with fibers, sequins, beads, paper, paint, and more  Amateur embroiderers and experienced needleworkers alike will love seeing their work from an artist’s point of view Get started with three small sample projects</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Irene Schlesinger
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing, Inc.,
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?68ef6819